module.exports = __webpack_public_path__ + "static/img/an3-mayor.a73bdd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/an3-mayor.png
// module id = 5yJz
// module chunks = 0